import { useContext } from "react";
import {
  TimelinePlaybackContext,
  VisTimelineContext,
} from "./timeline-playback-context";
import { VideoPlaybackContext } from ".";
import { PlaybackMediatorContext } from "./playback-mediator-context";

export const useTimelinePlayback = () => {
  const context = useContext(TimelinePlaybackContext);

  if (context === undefined) {
    throw new Error(
      "useTimelinePlayback must be used within a TimelinePlaybackProvider"
    );
  }
  return context;
};

export const useVisTimeline = () => {
  const context = useContext(VisTimelineContext);

  if (context === undefined) {
    throw new Error(
      "useVisTimeline must be used within a TimelinePlaybackProvider"
    );
  }
  return context;
};

export const useVideoPlayback = () => {
  const context = useContext(VideoPlaybackContext);

  if (context === undefined) {
    throw new Error(
      "useVideoPlayback must be used within a TimelinePlaybackProvider"
    );
  }
  return context;
};

export const usePlaybackMediator = () => {
  const context = useContext(PlaybackMediatorContext);

  if (context === undefined) {
    throw new Error(
      "usePlaybackMediator must be used within a PlaybackMediatorProvider"
    );
  }

  return context;
};
